module.exports = __webpack_public_path__ + "img/icon-zan.216aada8.png";